// src/reducers/carReducer.js
import {
  FETCH_CARS_REQUEST,
  FETCH_CARS_SUCCESS,
  FETCH_CARS_FAILURE,
  FETCH_CAR_DETAILS_REQUEST,
  FETCH_CAR_DETAILS_SUCCESS,
  FETCH_CAR_DETAILS_FAILURE,
} from '../actions/carActions';

const initialState = {
  cars: [],
  loading: false,
  error: null,
  car: null, // This should hold the specific car details
};

const carReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CARS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_CARS_SUCCESS:
      return { ...state, loading: false, cars: action.payload };
    case FETCH_CARS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_CAR_DETAILS_REQUEST:
      return { ...state, loading: true, error: null, car: null }; // Reset car details
    case FETCH_CAR_DETAILS_SUCCESS:
      return { ...state, loading: false, car: action.payload }; // Set the fetched car details
    case FETCH_CAR_DETAILS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default carReducer;
